import React from "react";
import { ArrowLeft, Lock } from "lucide-react";
import { Button } from "../ui/button";
import PaymentControls from "../PaymentControls";
import ProgressManager from "../ProgressManager";
import RevisionHistory from "../RevisionHistory";

export default function AcceptedQuoteView({ cur, editId, isPro, manualOverall, navigate, payInfo, progress, q, revHistory, saveProgress, savingProgress, sendReminder, set, setManualOverall, setPayInfo, setProgress }) {
  return (
      <div className="max-w-3xl mx-auto py-10 space-y-6" data-testid="editor-accepted-lock">
        <div className="bg-card border border-slate-200/80 rounded-xl shadow-sm p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4">
            <Lock style={{ width: 26, height: 26 }} className="text-emerald-600" />
          </div>
          <h1 className="text-xl font-extrabold tracking-tight text-slate-900">Preventivo firmato e bloccato</h1>
          <p className="text-sm text-slate-500 mt-2 leading-relaxed">
            Questo preventivo è stato accettato e firmato dal cliente{q.accepted_name ? ` (${q.accepted_name})` : ""}. Per garantirne la validità probatoria (eIDAS) non è più modificabile.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6">
            <Button variant="outline" data-testid="editor-accepted-back" onClick={() => navigate("/dashboard")}>
              <ArrowLeft style={{ width: 16, height: 16 }} className="mr-2" /> Torna alla Dashboard
            </Button>
            {q.public_token && (
              <Button data-testid="editor-accepted-view" onClick={() => window.open(`/p/${q.public_token}`, "_blank")}>
                Apri preventivo firmato
              </Button>
            )}
          </div>
        </div>

        {payInfo && <PaymentControls quoteId={editId} info={payInfo} currency={cur} onChange={(d) => setPayInfo((s) => ({ ...s, ...d }))} />}

        <ProgressManager title="Gestione Avanzamento Lavori" enabled={q.progress_enabled}
          onToggle={(v) => (isPro ? set("progress_enabled", v) : navigate("/billing"))}
          isPro={isPro} progress={progress} setProgress={setProgress}
          manual={manualOverall} setManual={setManualOverall}
          onSave={saveProgress} saving={savingProgress} onReminder={sendReminder} />
        <RevisionHistory history={revHistory} cur={cur} className="mt-6" />
      </div>
  );
}
